<template>
  <div class="reviews">
    <img
      class="reviews__cover"
      src="https://ik.imagekit.io/gocase/slides/1567/desktop/Reviews-banner-desktop.jpg"
      alt="Gocase Reviews"
    />
    <div id="stamped-reviews-widget" data-widget-type="full-page"></div>
    <div class="custom-loader custom-loader--pagination active"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    const apiKey = 'pubkey-N6Q727SNSTMMF2a42a9014li20wt17'
    const storeUrl = 'shop-gocase.com'

    if (typeof window.StampedFn !== 'undefined') {
      window.StampedFn.init({ apiKey, storeUrl })
      window.StampedFn.loadDisplayWidgets()
    }
  },
  head() {
    return {
      title: 'Gocase Reviews',
      meta: [
        {
          name: 'description',
          content:
            '✓Gocase Reviews ✓3933+ Ratings ✓High Quality ✓Customize it with your Name or Photo ✓Fast shipping to the United States and worldwide ✓Best Designs',
        },
      ],
      script: [
        {
          src: 'https://cdn-stamped-io.azureedge.net/files/widget.min.js',
        },
        {
          id: 'spree-jquery',
          src:
            'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js',
        },
      ],
    }
  },
}
</script>

<style>
.reviews__cover {
  width: 100%;
}
</style>
